import { Message } from '@arco-design/web-vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { setHtmlLang, saveLocale,getSavedLocale } from '@/locale';

export default function useLocale() {
    const {locale,t} = useI18n();
    const currentLocale = computed(() => {
        return locale.value;
    });
    const changeLocale = (value: string) => {
        if (locale.value === value) {
            return;
        }
        //更新 i18n 语言
        locale.value = value;

        // 同步到 HTML 和 localStorage
        setHtmlLang(value);
        saveLocale(value);
        Message.success(t('navbar.action.locale'));
        //window.location.reload();
    };
    return {
        currentLocale,
        changeLocale,
        getSavedLocale,
    };
}
